import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ShareBoxDetails } from '../business-entities/appointmentDetail-model';

@Pipe({
  name: 'stringtoshareboxdetails'
})
export class StringtoshareboxdetailsPipe implements PipeTransform {

  constructor(
    ) { 
      //this is intentional
    }
    transform(deatils: any): any {
        const arra =[]
        deatils.forEach(element => {
          if(element?.toString().includes(",")){
          let obj:ShareBoxDetails={
            kioskLocationId: 0,
            kioskLocationName: '',
            kioskLockerId: 0,
            date: new Date()
          }
          let arr = element.split(",");
          if(arr && arr.length >0){
            obj.kioskLocationId = arr[0];
            obj.kioskLocationName = arr[1];
            obj.date = (arr[2] == null || arr[2] == undefined) ? null : Utility.ConvertUTCDateToLocalDate(arr[2]);
            obj.kioskLockerId = arr[3];
          }
          arra.push(obj);
        }
           
        })
        return arra;
        
    }

}
